export const randomString = () => (Math.random() + 1).toString(36).substring(2);
